export default "__VITE_ASSET__DSvgDat1__"